"use client";

import { HeroSection } from './HeroSection';


function GetStarted() {
  return (
    <main className="flex overflow-hidden flex-col pb-20 ">
      <HeroSection />
    </main>
  );
}

export default GetStarted;
